<template>
  <v-app id="app" class="secondary">
    <v-navigation-drawer app temporary fixed v-model="drawer" v-if="withDrawer">
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-item v-if="displayName">
            <v-list-item-avatar>
              <img :src="photoURL">
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{displayName}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-toolbar>
      <v-list dense>
        <v-divider></v-divider>

        <v-list-item v-if="isAnonymous">
          <v-list-item-content>
            <v-list-item-title @click.stop="toggleLoginModal">
                Log in
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!isAnonymous">
          <v-list-item-content>
            <v-list-item-title @click.stop="signOut">
              Log out
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <a href="/about">
                About
              </a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title @click.stop="toggleFeedbackModal">
              App feedback
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app light color="transparent" flat ixed v-if="withHeader">
      <v-app-bar-nav-icon @click.stop="toggleDrawer" v-if="withDrawer" title="Menu"/>
      <v-btn text icon class="custom" @click="goBack" v-if="!withDrawer" key="back">
        <v-icon dark>chevron_left</v-icon>
      </v-btn>
      <div @click="gotoPresentMode" class="toolbar-logo" v-if="withLogo" key="logo">
        <img src="./assets/images/logo.svg" alt="At-And logo">
      </div>
      <v-toolbar-title v-if="!withLogo">
        {{headerTitle}}
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <router-view v-on:showLoginModal="openPersistentLoginModal"/>
    </v-content>

    <v-dialog v-model="showLoginModal" width="500" :persistent="persistentLoginModal">
      <login-modal @skipLogin="closePersistentLoginModal"
                   @loginModalClosed="closeLoginModal"
                   @stateChange="changeLoginModalState"
                   :skip="persistentLoginModal" :state="loginModalState"/>
    </v-dialog>

    <v-dialog v-model="showFeedbackModal" width="500">
      <app-feedback-modal @feedbackModalClosed="toggleFeedbackModal"/>
    </v-dialog>

    <v-snackbar v-model="showSystemMessage" color="primary">
      {{ systemMessage }}
      <v-btn dark text @click="showSystemMessage = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import loginModal from './components/LoginModal';
import appFeedbackModal from './components/AppFeedbackModal';

export default {
  name: 'App',

  components: {
    loginModal,
    appFeedbackModal
  },

  data: () => ({
    drawer: null,
    showLoginModal: null,
    showFeedbackModal: null,
    persistentLoginModal: false,
    loginModalState: undefined,
    tapCount: 0,
    showSystemMessage: false
  }),

  computed: {
    isHome() {
      return this.$route ? this.$route.name === 'home' : false;
    },
    withHeader() {
      return this.$route ? this.$route.name !== 'attending' && this.$route.name !== 'presenter' : true;
    },
    withDrawer() {
      return this.isHome;
    },
    withLogo() {
      return this.isHome;
    },
    headerTitle() {
      switch (this.$route.name) {
        case 'attending':
          return this.$store.getters.currentPresentation.title;
        default:
          return '';
      }
    },
    ...mapGetters([
      'displayName',
      'photoURL',
      'isAnonymous',
      'systemMessage'
    ])
  },

  watch: {
    systemMessage() {
      this.showSystemMessage = true;
    }
  },

  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    openPersistentLoginModal() {
      this.persistentLoginModal = true;
      this.toggleLoginModal();
    },
    closePersistentLoginModal() {
      this.persistentLoginModal = false;
      this.toggleLoginModal();
      this.$router.push({ name: 'home' });
    },
    closeLoginModal() {
      this.toggleLoginModal();
      this.$router.push({ name: 'home' });
    },
    toggleLoginModal() {
      this.drawer = false;
      this.showLoginModal = !this.showLoginModal;
      this.loginModalState = undefined;
    },
    signOut() {
      this.drawer = false;
      this.$store.dispatch('signOut');
    },
    toggleFeedbackModal() {
      this.showFeedbackModal = !this.showFeedbackModal;
    },
    changeLoginModalState(state) {
      this.loginModalState = state;
    },
    goBack() {
      switch (this.$route.name) {
        case 'view-presentation':
          this.$router.push({ name: 'presenter' });
          break;
        default:
          this.$router.push({ name: 'home' });
      }
    },
    gotoPresentMode() {
      if (this.tapCount >= 6) {
        this.$router.push({ name: 'present' });
      } else {
        this.tapCount += 1;
      }
    }
  }
};
</script>

<style lang="scss">
  .v-toolbar__content .v-btn--icon.custom {
    margin-left: -6px;
  }

  .v-navigation-drawer a {
    color: #000;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue